<template>
  <span>
    <div class="d-flex align-center">
      <label class="page-label">{{ $t('message.pages.live.adicionalQualitiesTitle') }}</label>

    </div>

    <p style="font-weight: 400px; font-size: 14px; line-height: 21px;">{{
      $t('message.pages.live.adicionaQualitiesSubtitle') }}</p>

    <ul class="mb-4">
      <li v-for="(quality, index) in adicionalQualities" :key="index" class="checkbox-item">
        <v-checkbox v-model="checkbox" :disabled="true"
          style="justify-content: center; align-items: center; text-align: center; height: 15px; border-color: transparent; background-color: var(--v-brand-primary);"></v-checkbox>
        <span class="mt-0 pt-0">{{ quality }}</span>
      </li>
    </ul>

  </span>
</template>

<script>
// external imports

// internal imports

import liveService from '@/services/liveServiceV2'

// API

// Components

export default {
  name: 'LiveQualities',
  inject: [
    'isPlanGold',
  ],
  props: {
    propsData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  data: () => ({
    checkbox: true,
    form: {
      disabled: false,
    },
    adicionalQualities: {},
  }),
  computed: {
    prices: {
      get() { return this.propsData['prices'] },
      set(value) { this.propsData['prices'] = value }
    },
    avalibleBitrates: {
      get() { return this.propsData['avalibleBitrates'] },
      set(value) { this.propsData['avalibleBitrates'] = value }
    },
  },
  methods: {

    async getLiveInfo() {
      const { data } = await liveService.getLive(this.$route.params.id)

      this.adicionalQualities = data.bitrate

    },
  },
  async mounted() {

    await this.getLiveInfo()
  },
  watch: {
    'form.disabled'(value) {
      if (!value) this.avalibleBitrates = []
    }
  },
}
</script>

<style lang="scss" scoped>
.d-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: $spacing-plus-1;
  row-gap: $spacing-minus-1;

  span {
    text-align: right;
  }
}

.checkbox-item {
  display: flex;
  align-items: center;
}

.checkbox-item v-checkbox {
  margin-right: 10px;
}

.feature-status {
  color: #4caf50;
  display: flex;
  align-items: center;
  position: absolute;
  top: -2;
  right: 0;
}

.adicionalQualities {
  color: #0B134A;
  font-size: 16px !important;
  font-weight: 400 !important;
  font-family: 'Rubik', sans-serif !important;
}

.disabled-section {
  opacity: 0.5;
  pointer-events: none;
}

.disabled-tab {
  cursor: not-allowed;
  opacity: 0.5;
}

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.bg-dark {

  .page-label {
    color: var(--v-primary-base) !important
  }
}
</style>
